import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../../components/layout";
import { Button, Modal, Select, Tabview } from "../../../../components/core";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
	BULK_CREATE_MESSAGE_TEMPLATE,
	CREATE_MESSAGE_TEMPLATE,
	LOCKER_TYPE_FOR_LOCKER_USER_TEMPLATE,
	OPERATOR_MESSAGE_TEMPLATE,
	UPDATE_MESSAGE_TEMPLATE,
} from "../../../../constants/graphql/message-template-queries";
import reactSelect from "react-select";
import TabComponent from "../../../../components/core/tab";
import { Strings } from "../../../../constants/strings";
import { TabviewTemplate } from "../components";
import { useSelector } from "react-redux";
import useSidebarStore from "../../../../zustand/stores/sidebar-store";
import { useNavigate } from "react-router-dom";
const MESSAGE_MEDIA = ["sms", "app"];
const MESSAGE_GROUP = [
	"Pick-up Alerts",
	"Shipout Alerts",
	"Storage",
	"Account Registration",
];
export default function LockerUserTemplate() {
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	const navigate = useNavigate();
	// Local States
	const [lockerTypeList, setLockerTypeList] = React.useState([]);
	const [lockerTypeValue, setLockerTypeValue] = React.useState("-1");
	const [messageGroupValue, setMessageGroupValue] = React.useState(
		MESSAGE_GROUP[0]
	);
	const [editingDone, setEditingDone] = useState(false);
	const [checked, setChecked] = useState(false);
	const [messageTemplateList, setMessageTemplateList] = React.useState([]);
	const [messageTemplateListOriginal, setMessageTemplateListOriginal] =
		React.useState([]);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const [checkedStates, setCheckedStates] = useState(
		messageTemplateList.reduce((acc, item) => {
			acc[item.operatorMessageTypeId] = false; // Initialize each to false
			return acc;
		}, {})
	);
	// zustand
	const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
	const setPendingNavigation = useSidebarStore(
		(state) => state.setPendingNavigation
	);
	const activeSubItem = useSidebarStore((state) => state.activeSubItem);
	const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);
	// GQL
	const lockerTypes = useQuery(LOCKER_TYPE_FOR_LOCKER_USER_TEMPLATE);
	const [operatorMessageTemplate, { data, loading, value, refetch }] =
		useLazyQuery(OPERATOR_MESSAGE_TEMPLATE);
	const [updateMessageTemplate] = useMutation(UPDATE_MESSAGE_TEMPLATE);
	// added create for message templates
	const [bulkCreateMessageTemplate] = useMutation(BULK_CREATE_MESSAGE_TEMPLATE);
	const [singleCreateMessageTemplate] = useMutation(CREATE_MESSAGE_TEMPLATE);
	// Handle Changes
	const handleChangeLockerTypeValue = (e) => {
		setEditingDone(false);
		setLockerTypeValue(e.target.value);
		operatorMessageTemplate({
			variables: {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				lockerTypeId: e.target.value,
				menuGroup: "Locker User Templates",
				messageGroup: messageGroupValue,
			},
		});
	};

	const handleOnTemplateChange = (event, operatorMessageTypeId) => {
		setEditingDone(true);
		let tempMessageTemplateList = [...messageTemplateList];
		const { name, value } = event.target;
		let index = tempMessageTemplateList.findIndex(
			(x) => x.operatorMessageTypeId === operatorMessageTypeId
		);

		tempMessageTemplateList[index][name] = value;
		setMessageTemplateList(tempMessageTemplateList);
	};

	const handleOnTabChanged = (tabValue) => {
		setMessageGroupValue(MESSAGE_GROUP[tabValue]);
		refetch({
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerTypeId: lockerTypeValue,
			menuGroup: "Locker User Templates",
			messageGroup: MESSAGE_GROUP[tabValue],
		});
	};
	const handleSaveChanges = () => {
		// Validation checks
		let isValid = true;
		for (const item of messageTemplateList) {
			if (item.messageViaApp.length > 1000) {
				isValid = false;
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: Strings.popup_error_title,
					message: Strings.popup_app_is_too_long,
					open: true,
					actions: (
						<div className="grid grid-cols-1 gap-2">
							<Button
								onClick={() => setValidation({ open: false })}
								value={"Go Back"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
				return; // Exit early if validation fails
			}
			if (item.messageViaSms.length > 320) {
				isValid = false;
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: Strings.popup_error_title,
					message: Strings.popup_sms_is_too_long,
					open: true,
					actions: (
						<div className="grid grid-cols-1 gap-2">
							<Button
								onClick={() => setValidation({ open: false })}
								value={"Go Back"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
				return; // Exit early if validation fails
			}
		}

		if (!isValid) return;

		// Process message template list
		const processedTemplates = messageTemplateList.map((item) => {
			const isChecked =
				checkedStates && checkedStates[item.operatorMessageTemplateId];

			// Create a clean copy of the item
			const processedItem = { ...item };

			// Apply checkbox rule
			if (isChecked) {
				processedItem.messageViaApp = processedItem.messageViaSms;
			}

			// Remove unnecessary fields
			delete processedItem.messageTitle;
			delete processedItem.checked;
			delete processedItem.messageViaAppDefault;
			delete processedItem.messageViaSmsDefault;
			delete processedItem.variableNames;

			// Process media array into comma-separated string
			processedItem.messageMedia = processedItem.messageMedia
				.filter((subItem) => subItem.checked === true)
				.map((subItem) => subItem.id)
				.join(",");

			return processedItem;
		});

		// Separate templates into two groups: to update and to create
		const templatesToUpdate = processedTemplates.filter(
			(item) =>
				item.operatorMessageTemplateId !== 0 &&
				item.operatorMessageTemplateId !== "0"
		);
		const templatesToCreate = processedTemplates.filter(
			(item) =>
				(item.operatorMessageTemplateId === 0 ||
					item.operatorMessageTemplateId === "0") &&
				// Only include templates where at least one message has content
				(item.messageViaSms.trim() !== "" || item.messageViaApp.trim() !== "")
		);

		// Handle both operations with Promise.all
		const operations = [];

		// Add update operation if there are templates to update
		if (templatesToUpdate.length > 0) {
			operations.push(
				updateMessageTemplate({
					variables: {
						operatorMessageTemplateArg: templatesToUpdate,
					},
				})
			);
		}

		// console.log({
		// 	templatesToCreate,
		// 	templatesToUpdate,
		// 	processedTemplates,
		// 	messageTemplateList,
		// });

		// Add create operation if there are templates to create
		if (templatesToCreate.length === 1) {
			// Use single create mutation for just one template
			const singleTemplate = templatesToCreate[0];
			operations.push(
				singleCreateMessageTemplate({
					variables: {
						input: {
							operatorMessageTemplateId:
								singleTemplate.operatorMessageTemplateId,
							operatorMessageTypeId: singleTemplate.operatorMessageTypeId,
							messageMedia: singleTemplate.messageMedia,
							messageViaSms: singleTemplate.messageViaSms,
							messageViaApp: singleTemplate.messageViaApp,
							operatorId: singleTemplate.operatorId,
							lockerTypeId: singleTemplate.lockerTypeId,
						},
					},
				})
			);
		} else if (templatesToCreate.length > 1) {
			// Use bulk create mutation for multiple templates
			operations.push(
				bulkCreateMessageTemplate({
					variables: {
						inputs: templatesToCreate,
					},
				})
			);
		}

		// Execute all operations
		Promise.all(operations)
			.then(() => {
				// Refetch data after successful operations
				refetch({
					operatorId: localStorage.getItem("user")
						? JSON.parse(localStorage.getItem("user")).operator_id
						: "",
					lockerTypeId: lockerTypeValue,
					menuGroup: "Locker User Templates",
					messageGroup: messageGroupValue,
				});

				// Show success message
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
					title: Strings.popup_success_title_default,
					message: Strings.popup_success_message_edit,
					open: true,
					actions: (
						<div className="grid grid-cols-1 gap-2">
							<Button
								onClick={() => {
									setValidation({ open: false });
									window.location.reload();
								}}
								value={"OK"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
			})
			.catch((e) => {
				// Show error message
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: Strings.popup_error_title,
					message: Strings.popup_error_message_edit,
					open: true,
					actions: (
						<div className="grid grid-cols-1 gap-2">
							<Button
								onClick={() => {
									setValidation({ open: false });
									window.location.reload();
								}}
								value={"OK"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
				console.error("Error saving message templates:", e);
			});
	};

	console.log({ messageTemplateList });

	const handleCancelChanges = () => {
		setValidation({ open: false });

		setMessageTemplateList(messageTemplateListOriginal);
		setEditingDone(false);
		window.location.reload();
	};
	// Use Effects
	useEffect(() => {
		if (pendingNavigation !== null) {
			if (editingDone) {
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: `${Strings.popup_confirm_cancel_title}?`,
					message: Strings.popup_confirm_cancel_massage,
					open: true,
					actions: (
						<div className="flex justify-between gap-3">
							<Button
								onClick={() => {
									setValidation({ open: false });
									// window.location.reload();
									setPendingNavigation(null);
									setActiveSubItem(activeSubItem);
								}}
								value={"No"}
								className={"p-2 w-full"}
							/>
							<Button
								onClick={() => {
									navigate(pendingNavigation);
									setPendingNavigation(null);
								}}
								value={"Yes"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
			} else {
				navigate(pendingNavigation);
				setPendingNavigation(null);
			}
		}
	}, [pendingNavigation, editingDone]);

	React.useEffect(() => {
		if (lockerTypes.data) {
			let tempVar = [];
			lockerTypes.data.lockerTypes.forEach((element) => {
				tempVar.push({ value: element.lockerTypeId, name: element.lockerType });
			});
			setLockerTypeList(tempVar);
		}
	}, [lockerTypes.data]);
	React.useEffect(() => {
		if (data) {
			let tempList = [];
			let tempCheckedStates = {};

			data.operatorMessageTemplates.forEach((element) => {
				const isChecked = element.messageViaApp === element.messageViaSms;

				let tempMessageMedia = [];
				MESSAGE_MEDIA.forEach((item) => {
					tempMessageMedia.push({
						id: item,
						text: item.toUpperCase(),
						checked: element.messageMedia.split(",").find((x) => x === item)
							? true
							: false,
					});
				});

				tempList.push({
					lockerTypeId: lockerTypeValue,
					operatorId: localStorage.getItem("user")
						? JSON.parse(localStorage.getItem("user")).operator_id
						: "",
					operatorMessageTemplateId: element.operatorMessageTemplateId,
					operatorMessageTypeId:
						element.operatorMessageType.operatorMessageTypeId,
					messageViaSms: element.messageViaSms,
					messageViaApp: element.messageViaApp,
					messageMedia: tempMessageMedia,
					// checked: isChecked,
					messageTitle: element.operatorMessageType.messageTitle,
					variableNames: element.operatorMessageType.variableNames
						.split(",")
						.map((subItem) => `$${subItem}`),
					messageViaSmsDefault:
						element.operatorMessageType.messageViaSmsDefault,
					messageViaAppDefault:
						element.operatorMessageType.messageViaAppDefault,
				});

				// Update checkedStates with the checked value
				tempCheckedStates[element.operatorMessageTemplateId] = isChecked;
			});

			// Update state with new data
			setMessageTemplateList(tempList);
			setMessageTemplateListOriginal(tempList);
			setCheckedStates(tempCheckedStates); // Update checkedStates
		}
	}, [data]);

	console.log({ messageTemplateList, checkedStates });

	const handleCheckedChange = (id, isChecked) => {
		setCheckedStates((prevState) => ({
			...prevState,
			[id]: isChecked,
		}));
	};
	return (
		<ContentContainer containerTitle={"Locker User Template"}>
			<div className="flex gap-2">
				<p className="my-auto">Locker Type: </p>
				<Select
					items={lockerTypeList}
					defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
					value={lockerTypeValue}
					onChange={handleChangeLockerTypeValue}
				/>
			</div>
			{lockerTypeValue !== "-1" && (
				<>
					<Tabview
						className="my-4 "
						items={[
							{
								header: "Pickup Alerts",
								body: (
									<TabviewTemplate
										disabled={
											accessPermission.lockerUserTemplates === "1" ||
											accessPermission.lockerUserTemplates === 1
										}
										checkedStates={checkedStates}
										handleCheckedChange={handleCheckedChange}
										// checked={checked}
										setChecked={setChecked}
										data={messageTemplateList}
										lockerType={
											lockerTypeList.find((x) => x.value === lockerTypeValue) &&
											lockerTypeList.find((x) => x.value === lockerTypeValue)
												.name
										}
										className="p-12"
										editingDone={editingDone}
										setEditingDone={setEditingDone}
										onChange={handleOnTemplateChange}
									/>
								),
								disabled: false,
							},
							{
								header: "Shipout Alerts",
								body: (
									<TabviewTemplate
										disabled={
											accessPermission.lockerUserTemplates === "1" ||
											accessPermission.lockerUserTemplates === 1
										}
										checkedStates={checkedStates}
										handleCheckedChange={handleCheckedChange}
										// checked={checked}
										setChecked={setChecked}
										data={messageTemplateList}
										lockerType={
											lockerTypeList.find((x) => x.value === lockerTypeValue) &&
											lockerTypeList.find((x) => x.value === lockerTypeValue)
												.name
										}
										setEditingDone={setEditingDone}
										onChange={handleOnTemplateChange}
									/>
								),
								disabled: true,
							},
							{
								header: "Storage",
								body: (
									<TabviewTemplate
										disabled={
											accessPermission.lockerUserTemplates === "1" ||
											accessPermission.lockerUserTemplates === 1
										}
										checkedStates={checkedStates}
										handleCheckedChange={handleCheckedChange}
										// checked={checked}
										setChecked={setChecked}
										data={messageTemplateList}
										lockerType={
											lockerTypeList.find((x) => x.value === lockerTypeValue) &&
											lockerTypeList.find((x) => x.value === lockerTypeValue)
												.name
										}
										setEditingDone={setEditingDone}
										onChange={handleOnTemplateChange}
									/>
								),
								disabled: false,
							},
							{
								header: "Account Registration",
								body: (
									<TabviewTemplate
										disabled={
											accessPermission.lockerUserTemplates === "1" ||
											accessPermission.lockerUserTemplates === 1
										}
										checkedStates={checkedStates}
										handleCheckedChange={handleCheckedChange}
										// checked={checked}
										setChecked={setChecked}
										data={messageTemplateList}
										lockerType={
											lockerTypeList.find((x) => x.value === lockerTypeValue) &&
											lockerTypeList.find((x) => x.value === lockerTypeValue)
												.name
										}
										setEditingDone={setEditingDone}
										onChange={handleOnTemplateChange}
									/>
								),
								disabled: false,
							},
						]}
						activeIndex={MESSAGE_GROUP.findIndex(
							(x) => x === messageGroupValue
						)}
						onTabChanged={handleOnTabChanged}
						setEditingDone={setEditingDone}
					/>

					<div
						className={`grid grid-cols-3 gap-2 w-2/3 pb-5 ${
							accessPermission.lockerUserTemplates === "1" ||
							accessPermission.lockerUserTemplates === 1
								? "hidden"
								: ""
						}`}
					>
						<Button
							disabled={
								accessPermission.lockerUserTemplates === "1" ||
								accessPermission.lockerUserTemplates === 1
							}
							// disabled={modifyingFlag}
							value={"Cancel"}
							className={`p-2 ${editingDone ? "" : "hidden"}`}
							onClick={() => {
								setValidation({
									icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
									title: Strings.popup_confirm_cancel_title,
									message: Strings.popup_confirm_cancel_massage,
									open: true,
									actions: (
										<div className="grid grid-cols-2 gap-2">
											<Button
												onClick={() => setValidation({ open: false })}
												value={"No"}
												className={"p-2 w-full"}
											/>
											<Button
												onClick={handleCancelChanges}
												value={"Yes"}
												className={"p-2 w-full"}
											/>
										</div>
									),
								});
							}}
						/>
						<Button
							// disabled={modifyingFlag}
							disabled={
								accessPermission.lockerUserTemplates === "1" ||
								accessPermission.lockerUserTemplates === 1
							}
							value={"Save Changes"}
							className={`p-2 ${editingDone ? "" : "hidden"}`}
							onClick={() => {
								setValidation({
									icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
									title: Strings.popup_confirm_save_title,
									message: Strings.popup_confirm_save_message_with_hours,
									open: true,
									actions: (
										<div className="grid grid-cols-2 gap-2">
											<Button
												onClick={() => setValidation({ open: false })}
												value={"No"}
												className={"p-2 w-full"}
											/>
											<Button
												onClick={handleSaveChanges}
												value={"Yes"}
												className={"p-2 w-full"}
											/>
										</div>
									),
								});
							}}
						/>
					</div>
				</>
			)}
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</ContentContainer>
	);
}
